import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const letter = (i) => String.fromCharCode(65 + i);

export const LocationGridForm = ({ onDone }) => {
  const [cols, setCols] = useState(4);
  const [shelves, setShelves] = useState(6);
  const [busy, setBusy] = useState(false);
  const c = Math.min(Math.max(Number(cols) || 0, 0), 26);
  const s = Math.min(Math.max(Number(shelves) || 0, 0), 50);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/locations/grid", { columns: c, shelves: s });
      toast.success(`${data.created} locations created${data.skipped ? ` (${data.skipped} already existed)` : ""}`);
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="space-y-4" data-testid="location-grid-form">
      <div className="grid grid-cols-2 gap-3">
        <label className="text-xs uppercase tracking-widest text-[#6E665D]">Columns (A–Z)
          <Input type="number" min="1" max="26" value={cols} onChange={(e) => setCols(e.target.value)} className="h-11 mt-2 text-base text-[#F5F0EB] normal-case tracking-normal" data-testid="grid-columns-input" />
        </label>
        <label className="text-xs uppercase tracking-widest text-[#6E665D]">Shelves per column
          <Input type="number" min="1" max="50" value={shelves} onChange={(e) => setShelves(e.target.value)} className="h-11 mt-2 text-base text-[#F5F0EB] normal-case tracking-normal" data-testid="grid-shelves-input" />
        </label>
      </div>
      {c > 0 && s > 0 && (
        <p className="text-sm text-[#A89F91]" data-testid="grid-preview">
          {c * s} locations: <span className="font-mono text-[#D4AF37]">A1 … {letter(0)}{s}</span>{c > 1 && <> to <span className="font-mono text-[#D4AF37]">{letter(c - 1)}1 … {letter(c - 1)}{s}</span></>}. Column = letter, shelf = number.
        </p>
      )}
      <Button type="submit" disabled={busy || !c || !s} className="w-full h-12 bg-[#D4AF37] hover:bg-[#E5A93C] text-[#0D0A0B]" data-testid="grid-create-button">
        {busy ? "Creating…" : "Create locations"}
      </Button>
    </form>
  );
};
